import { HIERARCHY_GROUPING } from "@ext/catalog/views/logic/utils/resolveGroupBy";
import { type PropertyID, SystemProperties } from "@ext/properties/models";

const toggleGrouping = (groupBy: PropertyID[], id: PropertyID): PropertyID[] => {
	if (id === SystemProperties.hierarchy) return HIERARCHY_GROUPING;

	const selected = groupBy.filter((value) => value !== SystemProperties.hierarchy);
	const next = selected.includes(id) ? selected.filter((value) => value !== id) : [...selected, id];

	return next.length ? next : HIERARCHY_GROUPING;
};

export default toggleGrouping;
